import { useEffect, useState } from "react"

export function useSortAndOrder<T extends {}>(
  data?: Array<T>,
  updatedAt?: number,
) {
  const [sorted, setSorted] = useState<Array<T> | undefined>(data)
  const [sortAndOrder, setSortAndOrder] = useState({ sort: "", order: "ASC" })
  const [isSorted, setIsSorted] = useState<boolean>(false)

  const applySort = ({ sort, order }: { sort: string; order: string }) => {
    return (data || []).sort(
      (a, b) =>
        (order === "ASC" ? -1 : 1) *
        (a[sort as keyof T] > b[sort as keyof T] ? 1 : -1),
    )
  }

  const onSort = (path: string) => {
    const newOrder =
      path !== sortAndOrder.sort
        ? "ASC"
        : sortAndOrder.order === "ASC"
          ? "DESC"
          : "ASC"

    const updated = { sort: path, order: newOrder }
    setSortAndOrder(updated)
    setSorted(applySort(updated))
    setIsSorted(!isSorted)
  }

  useEffect(() => {
    setSorted(applySort(sortAndOrder))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedAt])

  return { sortAndOrder, onSort, sorted, isSorted }
}
